import formatDate from 'owa-datetime/lib/formatters/formatDate';
import { getYear } from 'owa-datetime/lib/owaDate/getFields';
import { OwaDate } from 'owa-datetime/lib/schema';

/**
 * This method is almost same as getEwsRequestString but removes run time dependency on localization
 * which is not needed for making calendar events call.
 * @param date
 */
export function getMiniEwsRequestString(date: OwaDate) {
    // formatDate does not handle negative and small years correctly.
    // Negative numbers must be prefixed with -00 and we need to always have 4-digits.
    const year = getYear(date);
    const negPrefix = year < 0 ? '-00' : '';
    let yearStr = Math.abs(year).toString(10);
    while (yearStr.length < 4) {
        yearStr = '0' + yearStr;
    }
    return negPrefix + yearStr + formatDate(date, "-MM-dd'T'HH:mm:ss.l", {} as any);
}
